import { i18n } from 'i18next';
import moment from 'moment/moment';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { Partner } from 'thermia-react-container/types/types/partner';
import { InstallationConfig } from '../types/onsiteConfig';
import { Registration } from '../types/registrationTypes';
import { customerAndLocationData, customerAndLocationHeader } from './customerAndLocation';
import { deviceAndSystemData, deviceAndSystemHeader } from './deviceAndSystemHeader';
import { getFooter } from './footer';
import { getHeader } from './header';

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

interface Props {
  t: i18n['t'];
  registration: Registration;
  partner?: Partner;
  installationConfig: InstallationConfig;
}

const generatePdf = ({ registration, partner, t, installationConfig }: Props) => {
  try {
    const propertyType: string = registration.location?.propertyType || '';
    const cleanedPropertyType = propertyType.replace(/[^a-z0-9\s]+/gi, '');
    const installationDateMoment = moment(registration.location?.installationDate);
    const installationDateValidated = installationDateMoment.isValid() ? installationDateMoment.format('YYYY-MM-DD') : 'Error';
    const pdfFileName = `Thermia_registration_${cleanedPropertyType}_${installationDateValidated}.pdf`;
    const docDefinition: TDocumentDefinitions = {
      footer: getFooter(t, registration),
      content: [
        getHeader(t, partner),
        {
          margin: [0, 20, 0, 0],
          table: {
            widths: ['49%', '2%', '49%'],
            body: customerAndLocationHeader(t)
          },
          layout: 'lightHorizontalLines'
        },
        {
          margin: [0, 2, 0, 20],
          table: {
            headerRows: 1,
            widths: ['49%', '2%', '49%'],
            body: customerAndLocationData(t, registration, installationConfig)
          },
          layout: 'lightHorizontalLines'
        },
        {
          margin: [0, 2, 0, 0],
          table: {
            widths: ['49%', '2%', '49%'],
            body: deviceAndSystemHeader(t)
          },
          layout: 'lightHorizontalLines'
        },
        {
          margin: [0, 2, 0, 0],
          table: {
            headerRows: 1,
            widths: ['49%', '2%', '49%'],
            body: deviceAndSystemData(t, registration)
          },
          layout: 'lightHorizontalLines'
        }
      ],
      defaultStyle: {
        fontSize: 8,
        color: '#5C5C5C'
      },
      styles: {
        tableHeader: {
          bold: true,
          fontSize: 10,
          fillColor: '#D7E4F4'
        },
        tableBody: {
          fillColor: '#EDF3FA'
        }
      }
    };
    return pdfMake.createPdf(docDefinition).download(pdfFileName);
  } catch (e: any) {
    console.log('Could not create pdf', e?.message);
    throw e;
  }
};

export default generatePdf;
